import { encodeToBase64 } from '@interxfi/utilities/encoding/base64';

const EXCLUDED_REDIRECTS = ['/', '/accept-invitation', '/login', '/logout', '/register', '/forgot-password', '/reset-password'] as const;

export function getRedirectParameter(pathname: string, searchString: string = ''): string | undefined {
  if (pathname && !EXCLUDED_REDIRECTS.find((excludedPath) => pathname === excludedPath)) {
    return encodeToBase64(`${pathname}${searchString}`);
  }

  return undefined;
}
